import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    adminFilters: {
      display: 'flex',
      alignItems: 'center',
    },
    controlLabel: {
      marginLeft: 0,
    },
    strongText: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: 700,
      whiteSpace: 'nowrap',
    },
    expandIcon: {
      height: 20,
      width: 20,
      color: '#687C8D',
      pointerEvents: 'none',
      position: 'absolute',
      top: 8,
      right: 10,
    },
    selectContainer: {
      marginRight: theme.spacing(2),
      '& .MuiSelect-root': {
        height: 40,
        minWidth: '10em',
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 16,
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),
        fontWeight: 700,
      },
    },
    select: {
      height: 40,
    },
  }),
);
